<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import facilityTypeEnum from '../enums/facilityType'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                addressForm: () => import('../forms/AddressForm'),
                memberForm: () => import('../forms/MemberForm'),
                facilityFileForm: () => import('../forms/FacilityFileForm'),
                fields: [
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'text', text: 'Name', value: 'name', rules: [v => !!v || 'Name is required', v => !(v && v.length > 100) || 'Name must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'enum', text: 'Facility Type', value: 'facilityTypes', rules: [v => (v !== null && v !== '' && v.length !== 0) || 'Facility Type is required'], isRequired: true, isMultiple: true, items: enumService.enumAsSelectValueList(facilityTypeEnum) },
                    { type: 'address', text: 'Address', value: 'address', rules: [v => !!v || 'Address is required'], isRequired: true, form: () => import('./AddressForm'), apiMethod: 'Addresses', claim: 'Addresses' },
                    { type: 'files', text: 'Files', value: 'fileIds', parentColumnName: 'facilityId', form: () => import('../forms/FacilityFileForm') }
                ],
                apiMethod: 'Facilities',
                formTitle: 'Facility',
            }
        },
    };
</script>
